var _g, _g2, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.00 512.00",
    xmlSpace: "preserve",
    width: "100px",
    height: "100px",
    fill: "#f7801a",
    stroke: "#f7801a",
    strokeWidth: 9.216,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.048
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A9095"
    },
    d: "M256,69.385c11.803,0,21.46,9.657,21.46,21.46s-9.657,21.46-21.46,21.46 c-11.803,0-21.46-9.657-21.46-21.46S244.197,69.385,256,69.385z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.443,
    y: 326.902,
    style: {
      fill: "#8A9095"
    },
    width: 75.11,
    height: 37.555
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.443,
    y: 364.457,
    style: {
      fill: "#8A9095"
    },
    width: 75.11,
    height: 69.745
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "186.255,219.606 186.255,187.416 325.745,187.416 325.745,219.606 341.841,219.606 341.841,262.526 170.16,262.526 170.16,219.606 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "325.745,402.017 325.745,434.207 293.555,434.207 293.555,364.462 293.555,326.906 218.445,326.906 218.445,364.462 218.445,434.207 186.255,434.207 186.255,402.017 170.16,402.017 170.16,262.526 341.841,262.526 341.841,402.017 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "443.776,434.207 443.776,466.397 68.224,466.397 68.224,434.207 78.954,434.207 186.255,434.207 218.445,434.207 293.555,434.207 325.745,434.207 433.046,434.207 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A9095"
    },
    d: "M470.601,477.127v26.825H41.399v-26.825c0-5.902,4.829-10.73,10.73-10.73h16.095h375.552h16.095 C465.773,466.397,470.601,471.226,470.601,477.127z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 325.743,
    y: 402.013,
    style: {
      fill: "#8A9095"
    },
    width: 107.301,
    height: 32.19
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "186.255,402.017 186.255,434.207 78.954,434.207 78.954,402.017 95.049,402.017 170.16,402.017 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "341.841,219.606 325.745,219.606 325.745,187.416 433.046,187.416 433.046,219.606 416.951,219.606 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "78.954,187.416 186.255,187.416 186.255,219.606 170.16,219.606 95.049,219.606 78.954,219.606 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "416.951,219.606 416.951,402.017 341.841,402.017 341.841,262.526 341.841,219.606 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8A9095"
    },
    points: "170.16,219.606 170.16,262.526 170.16,402.017 95.049,402.017 95.049,219.606 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A9095"
    },
    d: "M470.601,160.59v26.825h-37.555H325.745H186.255H78.954H41.399V160.59 c0-5.902,4.829-10.73,10.73-10.73h32.19h343.362h32.19C465.773,149.86,470.601,154.689,470.601,160.59z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8A9095"
    },
    d: "M427.681,149.86H84.319L256,10.37L427.681,149.86z M277.46,90.845c0-11.803-9.657-21.46-21.46-21.46 c-11.803,0-21.46,9.657-21.46,21.46s9.657,21.46,21.46,21.46C267.803,112.305,277.46,102.648,277.46,90.845z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,61.337c-16.271,0-29.508,13.237-29.508,29.508s13.237,29.508,29.508,29.508c16.271,0,29.508-13.237,29.508-29.508 S272.27,61.337,256,61.337z M256,104.258c-7.396,0-13.413-6.016-13.413-13.413S248.604,77.432,256,77.432 c7.396,0,13.413,6.016,13.413,13.413S263.395,104.258,256,104.258z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M441.094,227.653v-32.19h37.555V160.59c0-10.353-8.424-18.778-18.778-18.778h-29.333L256,0L81.462,141.813H52.129 c-10.353,0-18.778,8.424-18.778,18.778v34.873h37.555v32.19h16.095v166.316H70.906v32.19h-10.73v32.19h-8.048 c-10.353,0-18.778,8.424-18.778,18.778V512h445.298v-34.873c0-10.353-8.424-18.778-18.778-18.778h-8.048v-32.19h-10.73v-32.19 h-16.095V227.653H441.094z M424.999,211.558h-91.206v-16.095h91.206V211.558z M387.443,369.827V227.653h21.46v166.316h-59.015 V227.653h21.46v142.173H387.443z M333.793,393.969h-16.095v32.19h-16.095V318.859h-91.206V426.16h-16.095v-32.19h-16.095V270.574 h155.586V393.969z M285.508,356.414h-59.015v-21.46h59.015V356.414z M226.492,372.509h59.015v53.65h-59.015V372.509z M333.793,254.478H178.207v-26.825h16.095v-32.19h123.396v32.19h16.095V254.478z M256,20.738l149.015,121.074h-298.03L256,20.738z M49.446,179.368V160.59c0-1.454,1.229-2.683,2.683-2.683h407.742c1.454,0,2.683,1.229,2.683,2.683v18.778H49.446z M87.002,195.463 h91.206v16.095H87.002V195.463z M140.652,369.827V227.653h21.46v166.316h-59.015V227.653h21.46v142.173H140.652z M87.002,410.064 h91.206v16.095H87.002V410.064z M459.871,474.445c1.454,0,2.683,1.229,2.683,2.683v18.778H49.446v-18.778 c0-1.454,1.229-2.683,2.683-2.683H459.871z M435.729,442.255v16.095H76.271v-16.095H435.729z M424.999,426.16h-91.206v-16.095 h91.206V426.16z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 239.903,
    y: 216.919,
    width: 32.19,
    height: 16.095
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetails);
export default __webpack_public_path__ + "static/media/bank_details.a3d94bd2ff38893a680df14dab4e0c83.svg";
export { ForwardRef as ReactComponent };